import apiClient from './api';
import {
  BranchIssueDto,
  CreateBranchIssueDto,
  UpdateBranchIssueDto,
} from '../types/branchIssues.types';

const BASE = '/branchissues';

export const branchIssuesService = {
  async getAll(params?: {
    branchId?: number;
    status?: string;
    fromDate?: string;
    toDate?: string;
  }): Promise<BranchIssueDto[]> {
    const response = await apiClient.get(BASE, { params });
    return response.data.data || response.data;
  },

  async getById(id: number): Promise<BranchIssueDto> {
    const response = await apiClient.get(`${BASE}/${id}`);
    return response.data.data || response.data;
  },

  async generateNumber(): Promise<string> {
    const response = await apiClient.get(`${BASE}/generate-number`);
    return (response.data.data || response.data).issueNumber;
  },

  async create(dto: CreateBranchIssueDto): Promise<BranchIssueDto> {
    const response = await apiClient.post(BASE, dto);
    return response.data.data || response.data;
  },

  async update(id: number, dto: UpdateBranchIssueDto): Promise<BranchIssueDto> {
    const response = await apiClient.put(`${BASE}/${id}`, dto);
    return response.data.data || response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async post(id: number): Promise<BranchIssueDto> {
    const response = await apiClient.post(`${BASE}/${id}/post`);
    return response.data.data || response.data;
  },

  async unpost(id: number): Promise<BranchIssueDto> {
    const response = await apiClient.post(`${BASE}/${id}/unpost`);
    return response.data.data || response.data;
  },
};
